import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { _ } from '@biesbjerg/ngx-translate-extract/dist/utils/utils';
import { ApplicationInformationItem } from '../model/application-information-item.model';
import { environment } from '../../environments/environment';

interface About {
  username: string;
  webUIVersion: string;
  webAPIVersion: string;
  database: string;
  databaseVersion: string;
  serverName: string;
}

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent {

  constructor(private translateService: TranslateService) {
  }

  title = this.translateService.instant(_('About'));
  about: About = {
    database: '',
    databaseVersion: '',
    serverName: '',
    username: '',
    webAPIVersion: '',
    webUIVersion: ''
  };

  @Input()
  isVisible = false;

  @Input()
  set details(applicationInformation: ApplicationInformationItem[]) {
    if (applicationInformation) {
      this.about.username = applicationInformation.find(item => item.Key === 'Username')?.Value;
      this.about.webUIVersion = environment.version;
      this.about.webAPIVersion = applicationInformation.find(item => item.Key === 'APIVersion')?.Value;
      this.about.database = applicationInformation.find(item => item.Key === 'DBName')?.Value;
      this.about.databaseVersion = applicationInformation.find(item => item.Key === 'DBVersion')?.Value;
      this.about.serverName = applicationInformation.find(item => item.Key === 'Servername')?.Value;
    }
  }

  @Output()
  isVisibleChange = new EventEmitter<any>();

  closeDialog(): void {
    this.isVisible = false;
    this.isVisibleChange.emit(this.isVisible);
  }
}
